import script from "./DurataTable3.vue?vue&type=script&setup=true&lang=js"
export * from "./DurataTable3.vue?vue&type=script&setup=true&lang=js"

import "./DurataTable3.vue?vue&type=style&index=0&id=5e46f7a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e46f7a4"]])

export default __exports__